<template>
  <div class="main-content">
    <!-- BradCrumb header Start-->
    <section class="inner-header-bg">
      <div class="container">
        <!-- Breadcrumb Start-->
        <div class="section-breadcrumb">
          <div class="container">
            <div class="row">
              <div
                class="col-md-12 justify-content-center align-self-center pb-2"
              >
                <div class="breadcrumb-content">
                  <div class="title-section">
                    <h1 class="title text-center text-white">
                      Live Stream
                    </h1>
                  </div>
                  <div class="breadcrumb-nav">
                    <ul class="breadcrumb-link text-center list-unstyled mb-0">
                      <li class="text-white">
                        <i class="mdi mdi-home theme-light-color pr-2"></i>
                        <a href="/#/">Home</a>
                      </li>
                      <li class="theme-light-color active">
                        Live Stream
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Breadcrumb End -->
      </div>
    </section>
    <!-- BradCrumb header End -->
    <!-- Body Area Start-->
    <section class="section container">
      <p class="px-3">
		<center>
		<h10 class="text-center"><sup style="color:red;"><b>LIVE</b></sup> 
       	Project Spectrum will be livestreaming from the Mentor Protege Summit 2023 in Orlando, FL on Wednesday, 29 March, starting at 9:00 AM EDT. During our session, Program Manager Kareem Sykes will speak to attendees about Project Spectrum's efforts to bolster cybersecurity for manufacturing and industry, including new and upcoming initiatives for the platform. We'll be showing other bits and bytes from the summit, so tune in!
		</h10>
		</center>
		</p>
	<div>
      <video-player :options='videoOptions' />
    </div>
    </section>
  </div>
</template>
<script>
import VideoPlayer from './VideoPlayer.vue'
  
  export default {
    name: 'VideoExample',
    components: {
      VideoPlayer
    },
    data() {
      return {
        videoOptions: {
          autoplay: true,
          controls: true,
          fluid: true,
          muted: true,
          // preload: 'auto',
          // width: '800px',
          // height: '800px',
          // aspectRatio: '9:16',
  
          playbackRates: [0.75, 1.0, 1.5, 2.0],
          sources: [
            {
              src:
                  'https://d30fccoywgrmnj.cloudfront.net/out/v1/3691b1188db3417581309e89144a1d9c/index.m3u8',
              type: 'application/x-mpegURL'
            }
          ]
        }
      }
    }
  }

</script>

<style scoped>

    .site-main {
    padding: 60px 0;
    display: inline-block;
    width: 100%;
    float: left;
    overflow: hidden;
}

.privacy-link-footer {
  color: #007bff;
}

.inner-header-bg {
  background-image: url('~@/assets/images/headers/resources.png');
  background-position: center center;
}

h3 {
  font-size: 1.2rem;
  margin-top: 1rem;
}
@import '~video.js/dist/video-js.css'

</style>
